/**
 * web/src/hooks/queries/useWorkflows.ts
 * List workflows scoped to an event with optional status/type filters.
 * Cache key: ['workflows', eventId, type, status]. The bare ['workflows']
 * prefix matches the WS hybrid update key in handleBroadcast (D-2.1) so
 * `refetchType: 'active'` invalidations apply to every variant.
 */
import { useQuery } from '@tanstack/react-query';
import { listWorkflows, type ListWorkflowsQuery } from '../../api/workflows';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches GET /api/workflows for the given filters.
 *
 * @param q optional filters (eventId / type / status)
 * @returns React Query result for Workflow[]
 * @sideEffects HTTP GET on first observer
 * @idempotent yes
 */
export function useWorkflows(q: ListWorkflowsQuery) {
  return useQuery({
    queryKey: qk.workflows.list(q),
    queryFn: () => listWorkflows(q),
    enabled: q.eventId != null, // don't fetch until we know the event
  });
}
